export default __webpack_public_path__ + "static/media/blogcard10.b278629c.png";